import type Owner from '@ember/owner';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensStrategyComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	trackingOrigin = 'strategy';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.mainActions = [
			{
				action: this.create,
				icon: 'Plus',
				text: 'New goal',
				isForCreating: true,
			},
		];
		this.skeletonImage = '/images/svg/skeleton-screens/goal.svg';

		this.arrowText = 'Click here to get started with your first goal';
	}
}
